import React, { useState } from 'react';
import PropTypes from 'prop-types';

const DeviceIdConfigSection = ({ onSendDeviceId, sending, disabled }) => {
  const [isActive, setIsActive] = useState(false);
  const [deviceId, setDeviceId] = useState('');

  const handleSubmit = () => {
    if (sending) return;
    if (deviceId === undefined || deviceId === null || String(deviceId).trim() === '') return;
    const parsedId = parseInt(deviceId, 10);
    if (isNaN(parsedId) || parsedId < 1) return;
    onSendDeviceId(parsedId);
  };

  const handleChange = (e) => {
    const val = e.target.value;
    // Strip non-digits (no spaces, decimals, or signs)
    const cleanVal = val.replace(/[^0-9]/g, '');
    if (cleanVal === '') {
      setDeviceId('');
      return;
    }
    const parsed = parseInt(cleanVal, 10);
    // Allow any integer greater than 0
    if (parsed > 0) {
      setDeviceId(cleanVal);
    }
  };

  const handleKeyDown = (e) => {
    // Proactively block space, dot, comma, signs, and exponential notation
    if ([' ', '.', ',', 'e', 'E', '-', '+'].includes(e.key)) {
      e.preventDefault();
      return;
    }
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <section className="config-device-id-section" aria-labelledby="device-id-section-title">
      <header className="config-device-id-header">
        <h6 id="device-id-section-title" className="text-muted small text-uppercase mt-0 mb-2 font-weight-bold config-preview-section-title">
          <strong>Cambiar ID de Lectora</strong>
        </h6>
      </header>

      <div className="config-device-id-form">
        <div className="config-device-id-row">
          <span id="device-id-toggle-label" className="config-device-id-label">
            Habilitar cambio de ID:
          </span>
          <label className="custom-toggle-switch mb-0">
            <input
              id="device-id-toggle-switch"
              type="checkbox"
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
              disabled={disabled || sending}
              aria-labelledby="device-id-toggle-label"
              aria-controls="device-id-config-inputs-container"
              aria-expanded={isActive}
            />
            <span className="toggle-slider" />
          </label>
        </div>

        {isActive && (
          <div id="device-id-config-inputs-container" className="device-id-config-inputs">
            <div className="config-device-id-row">
              <label htmlFor="device-id-input" className="config-device-id-label">
                Nuevo ID de la lectora:
              </label>
              <input
                id="device-id-input"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                value={deviceId}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                className="config-device-id-input"
                placeholder="Nuevo ID de la lectora (e.g. 1)"
                required
                disabled={disabled || sending}
              />
            </div>

            <div className="text-center py-2 mt-3">
              <button
                type="button"
                className="btn btn-admin-button active btn-send-config btn-send-device-id"
                disabled={disabled || sending || deviceId === undefined || deviceId === null || String(deviceId).trim() === ''}
                onClick={handleSubmit}
              >
                {sending ? 'Enviando...' : 'Cambiar ID'}
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

DeviceIdConfigSection.propTypes = {
  onSendDeviceId: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};

export default DeviceIdConfigSection;
